import { render, staticRenderFns } from "./PathwayCohortViewSections.vue?vue&type=template&id=8039e48a&"
import script from "./PathwayCohortViewSections.vue?vue&type=script&lang=js&"
export * from "./PathwayCohortViewSections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports